import { defaultMinMaxTime as defaultMinMaxTimeDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type MinMaxTime = {
    min_time: string;
    max_time: string;
};

export const defaultMinMaxTime = (): MinMaxTime[] => defaultMinMaxTimeDiagram();
